import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=c5dfd4f4&"
import script from "./Award.vue?vue&type=script&lang=js&"
export * from "./Award.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5dfd4f4')) {
      api.createRecord('c5dfd4f4', component.options)
    } else {
      api.reload('c5dfd4f4', component.options)
    }
    module.hot.accept("./Award.vue?vue&type=template&id=c5dfd4f4&", function () {
      api.rerender('c5dfd4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Award/components/common/Award.vue"
export default component.exports